import { EmptyObject } from '@ve/types/EmptyObject';

interface BlockParams {
    block?: true,
}

export default (params: {[key: string]: string}): BlockParams | EmptyObject => {
    const tourCriteria: BlockParams | EmptyObject = {};
    const element: string | undefined = params.block;
    if (element) {
        tourCriteria.block = !!element as true;
    }
    return tourCriteria;
};